import { FC, useState } from 'react'

import { copyText } from 'utils/copy-text'

import cn from 'classnames'

import CopyIcon from './icons/copy-icon.svg'
import CopyIconGrey from './icons/copy-icon-grey.svg'
import CopySuccessIcon from './icons/copy-success-icon.svg'

import styles from './styles.module.scss'

interface CopyButtonWithSuccessProps {
  value: string
  grey?: boolean
  className?: string
  successIconClassName?: string
  copyIconClassName?: string
  customIcon?: string
}

export const CopyButtonWithSuccess: FC<CopyButtonWithSuccessProps> = ({
  value,
  grey,
  className,
  successIconClassName,
  copyIconClassName,
  customIcon,
}) => {
  const [isCopied, setIsCopied] = useState(false)

  const copy = async (evt) => {
    evt.stopPropagation()
    setIsCopied(true)
    await copyText(value)
    setTimeout(() => {
      setIsCopied(false)
    }, 1500)
  }

  return (
    <button className={cn(styles.btn, className)} onClick={copy}>
      <img className={cn(styles.copy, copyIconClassName)} src={customIcon ? customIcon : grey ? CopyIconGrey : CopyIcon} alt="copy icon" />
      <img
        className={`${cn(styles.copySuccess, successIconClassName)} ${isCopied ? styles.active : ''}`}
        src={CopySuccessIcon}
        alt="copy success icon"
      />
    </button>
  )
}
